import { gql } from '@/__generated__';
import { CollectionsAccess_GetCollectionsForUserAccessQuery } from '@/__generated__/graphql';

export type CollectionForUserAccess =
  CollectionsAccess_GetCollectionsForUserAccessQuery['allCollections'][number];

export type AssignedCollectionForUserAccess =
  CollectionsAccess_GetCollectionsForUserAccessQuery['assignedCollections'][number];

const GET_COLLECTIONS_FOR_USER_ACCESS = gql(`#graphql
  query CollectionsAccess_GetCollectionsForUserAccess($organizationIds: [Int!], $accountId: Int!) {
    allCollections: collections(filter: { organizationIds: $organizationIds }) {
      id
      name
      type
      organizationId
      organization {
        id
        name
      }
    }
    assignedCollections: collections(filter: { accountId: $accountId }) {
      id
      name
      type
      organizationId
      organization {
        id
        name
      }
      accountCollectionRelationId(accountId: $accountId)
      callerCanManageAccess
    }
  }
`);

export default GET_COLLECTIONS_FOR_USER_ACCESS;
